import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-35dae02e")

_pushScopeId("data-v-35dae02e")
const _hoisted_1 = {
  class: "test",
  style: {"background-color":"pink"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "p-dialog-title" }, [
  /*#__PURE__*/_createVNode("span", { class: "-royalBlue" }, "최형식"),
  /*#__PURE__*/_createTextVNode("님을 관심의사로 등록하였습니다. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "label" }, "환불수단"),
    /*#__PURE__*/_createVNode("span", { class: "value" }, "신한카드(5740/일시불)")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "label" }, "환불 접수 번호"),
    /*#__PURE__*/_createVNode("span", { class: "value" }, "443630045")
  ]),
  /*#__PURE__*/_createVNode("li", null, [
    /*#__PURE__*/_createVNode("span", { class: "label" }, "환불 예정금액"),
    /*#__PURE__*/_createVNode("span", { class: "value" }, "3,000원")
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("인포")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("기본")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("확인")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Scroll = _resolveComponent("Scroll")
  const _component_SetResidentRegistrationNumber = _resolveComponent("SetResidentRegistrationNumber")
  const _component_RequestStep = _resolveComponent("RequestStep")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")
  const _component_Button = _resolveComponent("Button")
  const _component_Doctors = _resolveComponent("Doctors")
  const _component_DateNameFilter = _resolveComponent("DateNameFilter")
  const _component_OnlineCareIntro = _resolveComponent("OnlineCareIntro")
  const _component_SecondOpinionIntro = _resolveComponent("SecondOpinionIntro")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Scroll),
    _createVNode(_component_SetResidentRegistrationNumber),
    _createVNode("div", null, [
      _createVNode(_component_RequestStep, {
        kind: _ctx.RequestKindTypes.OnlineCare,
        step: _ctx.RequestSteps.ONE
      }, null, 8, ["kind", "step"])
    ]),
    _createVNode("div", null, [
      _createVNode(_component_RequestStep, {
        kind: _ctx.RequestKindTypes.SecondOpinion,
        step: _ctx.RequestSteps.TWO
      }, null, 8, ["kind", "step"])
    ]),
    _createVNode(_component_Checkbox, {
      class: "-royalBlue",
      modelValue: _ctx.checked,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checked = $event)),
      binary: true
    }, null, 8, ["modelValue"]),
    _createVNode("div", null, [
      _createVNode(_component_ConfirmDialog, { group: "defaultButton" }),
      _createVNode(_component_ConfirmDialog, {
        group: "isConfirm",
        isConfirm: true
      }, {
        title: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_ConfirmDialog, { group: "withInfo" }, {
        info: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.withInfo()))
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.defaultButton()))
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isConfirmButton()))
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Doctors, {
      notSelectable: true,
      required: true,
      isEditable: true,
      possibleTypes: _ctx.PossibleTypes.ALL
    }, null, 8, ["possibleTypes"]),
    _createVNode(_component_Doctors, {
      required: true,
      isEditable: true,
      possibleTypes: _ctx.PossibleTypes.ALL
    }, null, 8, ["possibleTypes"]),
    _createVNode(_component_DateNameFilter, { filterState: _ctx.state }, null, 8, ["filterState"]),
    _createVNode(_component_OnlineCareIntro),
    _createVNode(_component_SecondOpinionIntro, { class: "secondopinion-intro" })
  ]))
})